<template>
  <div class="loading-side-modal">
    <div class="background-opacity"></div>
    <div class="loading-gif-container">
      <img class="loading-gif" :src="cx_loading_gif" loading="lazy"/>
    </div>
  </div>
</template>

<script>
import LoadingSideModal from "@/components/Util/Loading/LoadingSideModal/LoadingSideModal";
export default LoadingSideModal;
</script>

<style lang="scss" scoped>
@import "LoadingSideModal.scss";
</style>
